<template>
    <v-card>
        <v-card-title class="justify-center">Virtual assistant: {{ assistant.name }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row class="pa-2 ma-0">
                <v-col cols=1 class="py-0 px-2">Assistant id        </v-col><v-col cols=11 class="py-0 px-2">{{ assistant.id }}</v-col>
                <v-col cols=1 class="py-0 px-2">Name                </v-col><v-col cols=11 class="py-0 px-2">{{ assistant.name }}</v-col>
                <v-col cols=1 class="py-0 px-2">Description         </v-col><v-col cols=11 class="py-0 px-2">{{ assistant.description }}</v-col>
                <v-col cols=1 class="py-0 px-2">Created at          </v-col><v-col cols=11 class="py-0 px-2">{{ assistant.created_date }}</v-col>
                <v-col cols=1 class="py-0 px-2">Model               </v-col><v-col cols=11 class="py-0 px-2">{{ assistant.model }}</v-col>
                <v-col cols=1 class="py-0 px-2">Temperature        </v-col><v-col cols=11 class="py-0 px-2">{{ assistant.temperature }}</v-col>
                <v-col cols=1 class="py-0 px-2">Instructions        </v-col><v-col cols=11 class="py-0 px-2">{{ assistant.instructions }}</v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="editAssistant">Edit Assistant</v-btn>  
            <v-btn color="error"   small @click="deleteAssistant">Delete assistant</v-btn>
        </v-card-actions>
        <cardVirtualAssistantEdit ref="cardVirtualAssistantEdit" @updateData="updateData"/>
        <cardVirtualAssistantDelete ref="cardVirtualAssistantDelete" @updateData="updateData"/>
    </v-card>
</template>

<script>
    import cardVirtualAssistantDelete from "@/components/syst/openai/cardVirtualAssistantDelete.vue";
    import cardVirtualAssistantEdit from "@/components/syst/openai/cardVirtualAssistantEdit.vue";

    export default {
        components: {
            cardVirtualAssistantDelete,
            cardVirtualAssistantEdit,
        },
        props: {
            assistant: {
                required: true,
            },
            models: {
                required: true,
            }
        },
        data() {
            return {
            }
        },
        methods: {
            editAssistant() {
                this.$refs.cardVirtualAssistantEdit.openDialog(this.assistant, this.models);
            },
            deleteAssistant() {
                this.$refs.cardVirtualAssistantDelete.openDialog(this.assistant);
            },
            updateData(data) {
                this.$emit("updateData", data)
            }
        }
    }
</script>
